import { Container, Typography, Paper, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChurchIcon from '@mui/icons-material/Church';

function Home() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <ChurchIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        
        <Typography variant="h4" component="h1" gutterBottom>
          Bem-vindo ao Sistema de Avisos TIB
        </Typography>

        <Typography variant="body1" paragraph>
          Este sistema permite gerenciar os avisos da igreja de forma organizada e eficiente.
          Você pode cadastrar novos avisos, anexar arquivos e filtrar por data.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate('/cadastro')}
          >
            Novo Aviso
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => navigate('/avisos')}
          >
            Ver Avisos
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => navigate('/exibir')}
          >
            Apresentar
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default Home; 